module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jYkNr"))).then(() => parcelRequire('d0iPb'));